class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));

    // Safari does not focus a link or a button when it is clicked, so pressing an option blurs the
    // summary to nothing at all — a focusout with a null relatedTarget. onFocusOut reads that as
    // "focus left the disclosure" and closes, and because that lands between mousedown and mouseup
    // the option is unrendered before the click can happen: the menu just shut and the link never
    // navigated. Taking focus on pointerdown keeps document.activeElement inside the disclosure, so
    // nothing closes and the browser's own click — and its default action — still runs. A press on
    // an option still ends up focusing that option where the browser does that, since its focus move
    // is the default action of this event and therefore runs after this listener.
    // <dropdown-sheet> does the same for the bottom-sheet presentation, for the same reason plus
    // scrolling — see assets/script-dropdown-sheet.js.
    this.content.setAttribute('tabindex', '-1');
    this.content.addEventListener('pointerdown', () => this.content.focus({ preventScroll: true }));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
